import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=db670c16&"
import script from "./Connection.vue?vue&type=script&lang=js&"
export * from "./Connection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports